import { apiGET } from './api';

export const getFoodDescriptions = () => apiGET('/food_descriptions');
